import Users from './users';
import Positions from './positions';
import General from './stats';
import Vehicles from './vehicles';
import Groups from './groups';
import Geofences from './geofences';
import Journeys from './journeys';
import Events from './events';

class API {
  constructor() {
    this.users = new Users(this);
    this.positions = new Positions(this);
    this.general = new General(this);
    this.vehicles = new Vehicles(this);
    this.groups = new Groups(this);
    this.geofences = new Geofences(this);
    this.journeys = new Journeys(this);
    this.events = new Events(this);
  }

  fetch(url, options) {
    options = options || {};
    const opts = {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'application/json',
      },
      ...options,
    };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_URL_PREFIX + url, opts)
        .then(res => {
          if (res.ok) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch(res => reject(res));
    });
  }

  fetchJson(url, opts) {
    return new Promise((resolve, reject) => {
      this.fetch(url, opts)
        .then(res => {
          res.json().then(json => {
            resolve(json);
          });
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export default new API();
